import { Box, Link } from "@mui/material";

import { useLocales } from "../../locales";
import { CommonWrap, ComomonAlert } from "../common";
import ContentWrap from "../../DocLayout/Content/Index";
import { Trans } from "react-i18next";
import { ADMIN_MERCHANT_SETTING_URL } from "@/config";
export default function Index() {
  const { translate, currentLang } = useLocales();
  return (
    <ContentWrap
      leftChildren={
        <CommonWrap>
          <Box id="testnet" className="title">
            {translate("sandbox_mode.title")}
          </Box>
          {currentLang.value === "en" && (
            <Box className="desc">
              <Trans i18nKey={"sandbox_mode.desc_"} t={translate as any}>
                s<strong></strong>
                <strong></strong>
                <strong></strong>
                <strong></strong>
              </Trans>
            </Box>
          )}
          {currentLang.value !== "en" && (
            <>
              <Box className="desc">{translate("sandbox_mode.desc_")}</Box>
              <Box className="desc">{translate("sandbox_mode.desc_1")}</Box>
              <Box className="title_1">{translate("sandbox_mode.title_")}</Box>

              <Box className="desc">
                <Trans
                  i18nKey={"sandbox_mode.title_desc_1"}
                  t={translate as any}
                >
                  s
                  <Link
                    rel="noopener"
                    className="link"
                    underline="always"
                    href={ADMIN_MERCHANT_SETTING_URL}
                    target="_blank"
                  >
                    s
                  </Link>
                </Trans>
              </Box>
            </>
          )}
          <Box className="desc">{translate("sandbox_mode.title_desc_2")}</Box>
          <Box pl={2}>
            <Box className="desc link">
              <Link
                href={"https://sepolia-faucet.pk910.de/"}
                target="_blank"
                rel="noopener"
                className="link"
                underline="always"
              >
                https://sepolia-faucet.pk910.de/
              </Link>{" "}
            </Box>
            <Box className="desc link">
              <Link
                href={"https://www.allthatnode.com/faucet/ethereum.dsrv"}
                target="_blank"
                rel="noopener"
                className="link"
                underline="always"
              >
                https://www.allthatnode.com/faucet/ethereum.dsrv
              </Link>{" "}
            </Box>
            <Box className="desc link">
              <Link
                href={"https://faucet.quicknode.com/drip"}
                target="_blank"
                rel="noopener"
                className="link"
                underline="always"
              >
                https://faucet.quicknode.com/drip
              </Link>{" "}
            </Box>
          </Box>
          <Box className="desc">{translate("sandbox_mode.title_desc_3")}</Box>
          <Box pl={2}>
            <Box className="desc link">
              <Link
                href={"https://sepolia.etherscan.io/[your txid]"}
                target="_blank"
                rel="noopener"
                className="link"
                underline="always"
              >
                https://sepolia.etherscan.io/[your txid]
              </Link>
            </Box>
          </Box>
          <Box className="desc">
            <Trans i18nKey={"sandbox_mode.title_desc_4"} t={translate as any}>
              s
              <Link
                rel="noopener"
                className="link"
                underline="always"
                href={ADMIN_MERCHANT_SETTING_URL}
                target="_blank"
              >
                s
              </Link>
            </Trans>
          </Box>
          <ComomonAlert>
            {translate("sandbox_mode.tips")}
            {currentLang.value !== "en" && (
              <>
                <br />
                {translate("sandbox_mode.tips_1")}
              </>
            )}
          </ComomonAlert>
        </CommonWrap>
      }
    />
  );
}
